import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import RoutesInfo from 'services/routesInfo';
import { AuthProvider } from 'services/auth-service';
import { datadogRum } from '@datadog/browser-rum';
import '@datadog/browser-logs/bundle/datadog-logs';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient();

declare global {
  interface Window {
    DD_LOGS: any;
  }
}

datadogRum.init({
  applicationId: '18a93c42-e7ef-460f-af26-e7bbe7788b99',
  clientToken: 'pubb99bc3544eea1f4c1e05b925c1663939',
  site: 'us3.datadoghq.com',
  service: 'b-line-dev',

  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sampleRate: 100,
  premiumSampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input'
});

window.DD_LOGS.init({
  clientToken: 'pubb99bc3544eea1f4c1e05b925c1663939',
  site: 'us3.datadoghq.com',
  forwardErrorsToLogs: true,
  sampleRate: 100
});

datadogRum.startSessionReplayRecording();

function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <BrowserRouter>
          <RoutesInfo />
        </BrowserRouter>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Slide}
          style={{ width: '400px' }}
        />
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
